module.exports = __webpack_public_path__ + "img/boho_rio_gift_mask.1df53dfb.svg";